import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

/* MODAL */
import { useModal } from 'hooks/modalContext';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

const ClientType = () => {
  const { openModal } = useModal();

  const [clientTypeList, setClientTypeList] = useState([{
    clientTypeSeq: 0,
    clientTypeName: '',
  }]);

  useEffect(() => {
    Common.isLogin();

    getClientTypeList();
  }, []);

  const getClientTypeList = () => {
    Server.sendGet('client/type', {}, getClientTypeListCallback).then();
  };

  const getClientTypeListCallback = res => {
    setClientTypeList(res?.['resultList']);
  };

  const handleAdd = () => {
    openModal({
      modalName: 'ClientTypeModal',
      modalData: {
        isRegi: true,
        data: {
          item: {},
          callback: getClientTypeList,
        },
      }
    });
  };

  const handleContent = item => {
    openModal({
      modalName: 'ClientTypeModal',
      modalData: {
        isRegi: false,
        data: {
          item: item,
          callback: getClientTypeList,
        },
      }
    });
  };

  return (
    <>
      <Inner>
        <Title>
          <TitHead>
            <i/>
            <h4>Client type</h4>
          </TitHead>
          <BtnDesc>
            <TitBtn onClick={handleAdd}>
              <Ic src='https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/add_ic.svg'/>
              <span>Client type Registration</span>
            </TitBtn>
          </BtnDesc>
        </Title>
        <Content>
          <Table>
            <colgroup>
              <col width='10%'/>
              <col width='80%'/>
              <col width='10%'/>
            </colgroup>
            <thead>
            <tr>
              <th>No</th>
              <th>Client Type</th>
              <th>Detail</th>
            </tr>
            </thead>
            <tbody>
            {clientTypeList?.map((item, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{item.clientTypeName}</td>
                <td>
                  <TitBtn onClick={() => handleContent(item)}>
                    <span>Detail</span>
                  </TitBtn>
                </td>
              </tr>
            ))}
            {Common.isEmpty(clientTypeList) &&
              <tr>
                <td colSpan={3} className={'none-data'}>
                  There is no data to output.
                </td>
              </tr>
            }
            </tbody>
          </Table>
        </Content>
      </Inner>
    </>
  );
}

const Inner = styled.div`
  flex: 1;
  background: #ffffff;
`;

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }
`;

const BtnDesc = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;
`;

const TitBtn = styled.button`
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  gap: 0 5px;
  background: ${props => (props['$Color'] ? '#0072b9' : '#a4a4a4')};
  border-radius: 5px;
  margin: auto;

  & span {
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
  }

  &:hover {
    background-color: ${props => (props['$Color'] ? '#075C97' : '#7e7e7e')};
  }
`;

const Ic = styled.img.attrs({ alt: 'Util Icon' })``;

const Content = styled.div`
  margin-top: 35px;
  position: relative;
  height: 729px;
  overflow-y: scroll;
`;

const Table = styled.table`
  position: relative;

  & th {
    padding:15px 0;
    font-weight: 400;
    font-size: 18px;
    color: #777777;
    background: #f8f8f8;
    text-align: center;
    border-bottom: 1px solid #eeeeee;
    vertical-align: middle;
  }

  & td {
    padding: 10px 0;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    text-align: center;
    vertical-align: middle;
    border-bottom: 1px solid #eeeeee;
    border-left: 1px solid #eeeeee;
  }

  & thead {
    position: sticky;
    top: 0;
  }

  & tbody > tr {
    cursor: pointer;

    &:hover {
      & td {
        background: #f4f4f4;
      }
    }
  }

  & tr td.none-data {
    height: 572px;
    border: 0;
  }

  & tr td:first-child {
    border-left: none;
  }

  & tr:nth-child(even) {
    background: #fcfcfc;
  }
`;

export default ClientType;